import { alpha, Box, Chip, styled } from '@mui/material'

interface FilterChipProps {
  active: boolean
  main: string
  text: string
  tint: string
}

// Pill-shaped type filter. Colours derive from the per-type palette; the active state
// fills with the tint and adopts the deep readable text colour.
export const FilterChip = styled(Chip, {
  shouldForwardProp: prop => !['active', 'main', 'text', 'tint'].includes(prop as string),
})<FilterChipProps>(({ active, main, text, tint }) => ({
  fontWeight: 600,
  borderRadius: '999px',
  height: 32,
  border: `1.5px solid ${active ? alpha(main, 0.45) : 'rgba(100, 116, 139, 0.22)'}`,
  backgroundColor: active ? tint : 'transparent',
  color: active ? text : 'rgba(71, 85, 105, 0.85)',
  transition: 'all .15s ease',
  '& .MuiChip-icon': { borderRadius: '50%' },
  '&:hover': { backgroundColor: active ? tint : alpha(main, 0.08), borderColor: alpha(main, 0.45) },
}))

interface FilterChipDotProps {
  main: string
  active: boolean
}

// Legend dot rendered as the chip icon.
export const FilterChipDot = styled(Box, {
  shouldForwardProp: prop => !['main', 'active'].includes(prop as string),
})<FilterChipDotProps>(({ theme, main, active }) => ({
  width: 9,
  height: 9,
  borderRadius: '50%',
  marginLeft: theme.spacing(1.25),
  backgroundColor: main,
  opacity: active ? 1 : 0.45,
  transition: 'opacity .15s ease',
}))
